import { forwardRef } from 'react';
import { useGetTypographyStyle } from '~/elc/features/enterprise-settings/api';
import { RichTextContent, type RichTextContentProps } from '../RichTextContent';
import { typographyStyleToStringCSS } from '../../utils/typographyStyleToCSS';

export const StyledRichTextContent = forwardRef<HTMLDivElement, RichTextContentProps>((props, forwardedRef) => {
  const { data: customStyles, isLoading } = useGetTypographyStyle();

  if (isLoading || !customStyles) return null;

  const formattedStyles = Object.keys(customStyles).length > 0 ? typographyStyleToStringCSS(customStyles) : undefined;

  return <RichTextContent ref={forwardedRef} customElementStyles={formattedStyles} {...props} />;
});
